import { Modal } from '@mantine/core';
import {
  useAuditEffectsModal,
  useAuditEffectsModalWhere,
} from './useAuditEffectsModal';
import { AuditEffectsTable } from './AuditEffectsTable';
import { useAuditEffectsTableQuery } from './useAuditEffectsTableQuery';

export const AuditEffectsModal = () => {
  'use memo';

  const { close: closeModal } = useAuditEffectsModal();

  const where = useAuditEffectsModalWhere();
  const queryData = useAuditEffectsTableQuery({ skip: !where });

  return (
    <Modal
      opened={!!where}
      onClose={closeModal}
      title={'Effects History'}
      size={1600}
      zIndex={300}
      centered
      radius="lg"
      styles={{
        title: {
          fontWeight: 500,
        },
        body: {
          display: 'flex',
          flexDirection: 'column',
          paddingBottom: 0,
          paddingTop: 2,
          minHeight: '80dvh',
        },
      }}
    >
      <AuditEffectsTable queryData={queryData} />
    </Modal>
  );
};
